import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FAMLY_REPORT';

export const {
    action: fetchReport,
    success: fetchReportSuccess,
    failed: fetchReportFailed,
} = createAction(
    `${domain}/FETCH_REPORT`,
    institutionId => ({institutionId}),
    response => ({response}),
);

export const {action: setParentTab} = createAction(`${domain}/SET_PARENT_TAB`, tabId => ({tabId}));

export const {action: setEmployeeTab} = createAction(`${domain}/SET_EMPLOYEE_TAB`, tabId => ({tabId}));
